import { catchError } from "rxjs/operators";
import { HttpHelper } from "src/app/shared/class/HttpHelper";
import { Helper } from "src/app/shared/helpers/helper";
import { BASE_BACKEND } from "src/app/shared/http/api";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../shared/services/auth.service";
export class UmovmeEnvironmentService {
    constructor(http, authService) {
        this.http = http;
        this.authService = authService;
        this.httpHelper = new HttpHelper();
    }
    list(filters) {
        return this.http
            .get(`${BASE_BACKEND}umovme-environment/${this.httpHelper.getQueryParams(filters, true)}`)
            .pipe(catchError(Helper.handleError));
    }
    all() {
        console.log("GET ALL");
        return this.http
            .get(`${BASE_BACKEND}umovme-environment/all`)
            .pipe(catchError(Helper.handleError));
    }
    detail(id) {
        return this.http
            .get(`${BASE_BACKEND}umovme-environment/details/${id}`)
            .pipe(catchError(Helper.handleError));
    }
    save(body) {
        return this.http
            .post(`${BASE_BACKEND}umovme-environment/`, body)
            .pipe(catchError(Helper.handleError));
    }
    update(body) {
        return this.http
            .put(`${BASE_BACKEND}umovme-environment/`, body)
            .pipe(catchError(Helper.handleError));
    }
    remove(id) {
        return this.http
            .delete(`${BASE_BACKEND}umovme-environment/${id}`)
            .pipe(catchError(Helper.handleError));
    }
}
UmovmeEnvironmentService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UmovmeEnvironmentService_Factory() { return new UmovmeEnvironmentService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AuthService)); }, token: UmovmeEnvironmentService, providedIn: "root" });
